const DropDownIcon = ({dropDown, onClick, themeColor}) =>{
    return(
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
            transform: dropDown ? "rotate(180deg)" : "",}} onClick={onClick}>
        <path d="M11.0503 2.11011L7.02235 6.0369C6.82462 6.22966 6.50806 6.22564 6.3153 6.02791L2.38851 1.99996" stroke={themeColor} strokeWidth="3" strokeLinecap="round"/>
        </svg>
    )
}
export default DropDownIcon